const store = require('store');
const expirePlugin = require('store/plugins/expire');

store.addPlugin(expirePlugin);

export default class LocalStorage {
  static atribuir(chave, valor) {
    return store.set(chave, valor);
  }

  static obter(chave) {
    return store.get(chave);
  }

  static remover(...chaves) {
    chaves.forEach(chave => store.remove(chave));
  }

  static limparRegistros() {
    return store.each((key) => { if (key !== 'usuario') this.remover(key); });
  }
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js